import type { DashboardDto } from "@stryker/core/types/dashboard";
import DynamicTable from "@/components/dashboard/DynamicTable";
import { Typography } from "@/components/ui/typography";

type JobCountPieProps = {
  graphsData?: DashboardDto["jobPieChart"];
};
export default function JobCountTables({ graphsData }: JobCountPieProps) {
  return (
    <div className="flex flex-col gap-8 p-4">
      <div>
        <Typography variant="text-lg" className="font-semibold mb-2">
          Job % by branch
        </Typography>
        <DynamicTable data={graphsData?.byBranch.map((v) => jobsCountToPercentage(v)) ?? []} />
      </div>
      <div>
        <Typography variant="text-lg" className="font-semibold mb-2">
          Job % by plant
        </Typography>
        <DynamicTable data={graphsData?.byPlant.map((v) => jobsCountToPercentage(v)) ?? []} />
      </div>
      <div>
        <Typography variant="text-lg" className="font-semibold mb-2">
          Job % by person
        </Typography>
        <DynamicTable data={graphsData?.byPerson.map((v) => jobsCountToPercentage(v)) ?? []} />
      </div>
      <div>
        <Typography variant="text-lg" className="font-semibold mb-2">
          Job % by kit size
        </Typography>
        <DynamicTable
          data={
            graphsData?.byKitsSize.map((v) => {
              return jobsCountToPercentage(v);
            }) ?? []
          }
        />
      </div>
    </div>
  );
}

const jobsCountToPercentage = (v: any) => {
  return {
    ...v,
    jobs: Number.parseFloat((v.jobs * 100).toFixed(1)) + "%",
  };
};
